module.exports = __webpack_public_path__ + "img/Step4.f93467f8.png";